import {DateInput, ListProps, TextInput,} from "ra-ui-materialui";
import {useOptions} from "../../shared/hooks/useOptions";
import {initField} from "../../shared/utils";
import {DocumentDatagrid} from "./DocumentDatagrid";
import {CustomList} from "../../components/CustomList";

export const DocumentList = (props: ListProps) => {

    const { data: options } = useOptions("document", "GET");
    const filetr = options && [
        <TextInput {...initField("id", options)} label="Id" />,
        <TextInput {...initField("category_document.name", options)} label="Tipo Documento"/>,
        <DateInput
            {...initField("expiration_date", options)}
            label="Data scadenza"
        />,
    ];

    return (
        <CustomList
            filters={filetr}
            {...props}
        >
            <DocumentDatagrid
                options={options}
            />
        </CustomList>
    )
};

